import {gql} from '@apollo/client';

export const boardViewQueries = {
    GET_BOARD_VIEWS_BY_BOARD_ID: gql`
        query boardViewsByBoardId($boardSlug: String!) {
            boardViews(where: {board: {slug: {eq: $boardSlug}}, active: {eq: true}}, order: [{order: ASC}]) {
                nodes {
                    id
                    title
                    description
                    boardViewType
                    itemView
                    order
                    boardId
                }
            }
        }
    `,
    GET_BOARD_VIEW_BY_ID: gql`
        query boardViewById($id: UUID!) {
            boardViewById(id: $id) {
                id
                title
                description
                boardViewType
                itemView
                order
                boardId
            }
        }
    `,
    GET_BOARD_VIEWS: gql`
        query boardViews {
            boardViews {
                nodes {
                    id
                    title
                    description
                    boardViewType
                    itemView
                    order
                    boardId
                }
            }
        }
    `,
};
